import { render } from "./EditPresentation.vue?vue&type=template&id=671c0c58"
import script from "./EditPresentation.vue?vue&type=script&lang=js"
export * from "./EditPresentation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__